import React, { useState } from "react"
import UpdateConfirmAppointmentCard from "../UpdateConfirmAppointmentCard"
import UpdateCalendar from "../UpdateCalendar"

import "./styles.css"

const UpdateConfirm = ({
  appointment,
  handleSetView,
  setSelectedEvent,
  selectedEvent,
  setQuantity,
  quantity,
  originalQty,
  canCancel,
}) => {
  // Update appointment quantity
  const updateQuantity = (idToUpdate, value, increment = false) => {
    const newVal = Number(quantity) + Number(value)
    if (newVal >= 1 && newVal <= appointment.spots) {
      setQuantity(newVal)
    }
  }
  return (
    <>
      <UpdateConfirmAppointmentCard
        appointment={appointment}
        updateQuantity={updateQuantity}
        quantity={quantity}
        originalQty={originalQty}
        canCancel={canCancel}
      />
      <UpdateCalendar
        appointment={appointment}
        spots={appointment.spots}
        setSelectedEvent={setSelectedEvent}
        selectedEvent={selectedEvent}
      />
    </>
  )
}

export default UpdateConfirm
